<div mat-dialog-title>
  <span i18n>Мастер установки облицовки торца</span>

  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="no-padding h-[70vh] flex flex-col">
  <mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step #sideSelectStep [completed]="false" [editable]="false">
      <ng-template i18n matStepLabel>Выберите стороны</ng-template>
    </mat-step>

    <mat-step [completed]="false" [editable]="false" #adderStep>
      <ng-template i18n matStepLabel>Добавьте облицовку</ng-template>
    </mat-step>
  </mat-horizontal-stepper>

  <mat-divider> </mat-divider>

  <div class="flex-auto overflow-hidden">
    <csl-countertop-schema
      [ngClass]="{ hidden: stepper.selectedIndex !== 0 }"
      (sideSelectorClick)="sideSelected($event.sideNumber)"
      #schema></csl-countertop-schema>

      <csl-material-base-butts
        class="h-full flex flex-col"
        *ngIf="stepper.selectedIndex === 1 && !hasMatchedButts"
        (selectionChange)="selectedBanding = $event"
        [panelThickness]="data.countertopThickness"
        [showQuantityInStock]="data.showQuantityInStock" />
      <csl-edges-in-color
        *ngIf="stepper.selectedIndex === 1 && hasMatchedButts"
        (selectionChange)="selectedBanding = $event[0]"
        [panelThickness]="data.countertopThickness"
        [materialInMatBaseId]="data.materialInMatBaseId"
        [showQuantityInStock]="data.showQuantityInStock"
        (selectedFromMatBase)="selectedBanding = $event; saveAndClose()" />
  </div>
</div>

<div mat-dialog-actions>
  <button
    i18n
    mat-raised-button
    color="accent"
    (click)="goToEdgeBandingSelect()"
    [disabled]="!sideNumbers.size"
    *ngIf="stepper.selectedIndex === 0"
    >Далее</button
  >

  <button
    i18n
    mat-raised-button
    color="accent"
    (click)="saveAndClose()"
    [disabled]="!selectedBanding"
    *ngIf="stepper.selectedIndex !== 0"
    >ОК</button
  >
  <button i18n mat-button [mat-dialog-close]>ОТМЕНА</button>
</div>
